import React, { TextareaHTMLAttributes } from 'react';
import { FieldLabel } from './FieldLabel';


export interface TextAreaProps
    extends TextareaHTMLAttributes<HTMLTextAreaElement> {
    label?: React.ReactNode;               
    containerClassName?: string;
}


export function TextArea({ label, containerClassName, className, ...rest }: TextAreaProps) {
    return (
        <label className={["block space-y-2", containerClassName].filter(Boolean).join(' ')}>
            {label && <FieldLabel>{label}</FieldLabel>}
            <textarea
                className={[
                    'w-full rounded-xl border border-white/10 bg-white/5 px-4 py-3 text-white font-montserrat placeholder:text-slate-500 resize-none',
                    'focus:outline-none focus:ring-2 focus:ring-[#ff8a4a]/60 focus:border-[#ff8a4a]/60 transition-all',
                    className || ''
                ].join(' ')}
                {...rest}
            />
        </label>
    );
}